import { axiosPost } from "./ajaxServices";
import {
  urlGetClubSite,
  urlSaveClubSite,
  urlGetClubHomepage,
  urlSaveClubHomepage,
  urlDeleteClubHomepage,
  urlGetSubdomainFiles,
} from "./CONSTANTS";

// Fetch single club_site row by club
export const apiGetClubSite = ({ token, club_id }) => {
  return axiosPost(urlGetClubSite, { token, club_id });
};

// Create/update club_site with optional logos (multipart)
export const apiSaveClubSite = ({ token, club_id, domain, site_title, site_subtitle, logo_left, logo_right }) => {
  const formData = new FormData();
  formData.append("token", token);
  formData.append("club_id", club_id);
  formData.append("domain", domain);
  formData.append("site_title", site_title);
  if (site_subtitle !== undefined && site_subtitle !== null) {
    formData.append("site_subtitle", site_subtitle);
  }

  // Only append files if a File/Blob is provided; otherwise let backend keep existing value
  if (logo_left instanceof File || logo_left instanceof Blob) {
    formData.append("logo_left", logo_left);
  }
  if (logo_right instanceof File || logo_right instanceof Blob) {
    formData.append("logo_right", logo_right);
  }

  return axiosPost(urlSaveClubSite, formData);
};

// Fetch club_homepage rows for a club
export const apiGetClubHomepage = ({ token, club_id }) => {
  return axiosPost(urlGetClubHomepage, { token, club_id });
};

// Upsert a homepage row (supports file upload). Backend should name the file using club_id + "db-item-" + id.
export const apiSaveClubHomepage = ({ token, club_id, id, title, description, font_color, image, info_page_enabled, info_page_content, info_page_type, info_page_file }) => {
  const formData = new FormData();
  formData.append("token", token);
  formData.append("club_id", club_id);
  if (id) formData.append("id", id);
  formData.append("title", title);
  if (description !== undefined && description !== null) {
    formData.append("description", description);
  }
  if (font_color) {
    formData.append("font_color", font_color);
  }
  if (image instanceof File || image instanceof Blob) {
    formData.append("image", image);
  }
  // Info page fields
  if (info_page_enabled !== undefined && info_page_enabled !== null) {
    formData.append("info_page_enabled", info_page_enabled);
  }
  if (info_page_content !== undefined) {
    formData.append("info_page_content", info_page_content || "");
  }
  if (info_page_type !== undefined) {
    formData.append("info_page_type", info_page_type || "custom");
  }
  if (info_page_file !== undefined) {
    formData.append("info_page_file", info_page_file || "");
  }
  return axiosPost(urlSaveClubHomepage, formData);
};

// Get list of HTML/PHP files in subdomain directory
export const apiGetSubdomainFiles = ({ token, domain }) => {
  return axiosPost(urlGetSubdomainFiles, { token, domain });
};

export const apiDeleteClubHomepage = ({ token, club_id, id }) => {
  return axiosPost(urlDeleteClubHomepage, { token, club_id, id });
};
